import { cloneDeep } from 'lodash';

import { DEFAULT_TABLE_CONFIG } from '../../const/tableConfig';
import * as actions from './actions';
import * as getters from './getters';
import * as mutations from './mutations';

export default {
  namespaced: true,
  getters,
  mutations,
  actions,
  state: {
    mpkProjectDepartments: [],
    mpkProjectMinRoles: [],
    mpkListProjects: [],
    mpkProjectSupportMeasures: [],
    mpkProjectCategories: [],
    mpkProjectTypeEntries: [],
    lightSearchMpkProjects: [],
    investmentsSum: 0,
    mpkCommissionList: [],
    userProjectConfig: cloneDeep(DEFAULT_TABLE_CONFIG),
    isTableConfigNew: true,
  },
};
